/** Where users get DNClient Desktop, which they sign in to with an endpoint OIDC provider to enroll. */
export const DOWNLOADS_URL = 'https://www.defined.net/downloads/';
